/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Misc_Posts_PublishedInputs */

const id_misc_posts_published = /** @type {(inputs: Misc_Posts_PublishedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Diterbitkan pada 30 November 2023`)
};

const ms_misc_posts_published = /** @type {(inputs: Misc_Posts_PublishedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Diterbitkan pada 30 November 2023`)
};

const da_misc_posts_published = /** @type {(inputs: Misc_Posts_PublishedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Udgivet den 30. november 2023`)
};

const de_misc_posts_published = /** @type {(inputs: Misc_Posts_PublishedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Veröffentlicht am 30. November 2023`)
};

const en_us2_misc_posts_published = /** @type {(inputs: Misc_Posts_PublishedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Published on November 30, 2023`)
};

const es_es2_misc_posts_published = /** @type {(inputs: Misc_Posts_PublishedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Publicado el 30 de noviembre de 2023`)
};

const es_mx2_misc_posts_published = /** @type {(inputs: Misc_Posts_PublishedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Publicado el 30 de noviembre de 2023`)
};

const fil_misc_posts_published = /** @type {(inputs: Misc_Posts_PublishedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nai-publish noong Nobyembre 30, 2023`)
};

const fr_misc_posts_published = /** @type {(inputs: Misc_Posts_PublishedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Publié le 30 novembre 2023`)
};

const it_misc_posts_published = /** @type {(inputs: Misc_Posts_PublishedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pubblicato il 30 novembre 2023`)
};

const hu_misc_posts_published = /** @type {(inputs: Misc_Posts_PublishedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Közzétéve: 2023. november 30.`)
};

const nl_misc_posts_published = /** @type {(inputs: Misc_Posts_PublishedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gepubliceerd op 30 november 2023`)
};

const no_misc_posts_published = /** @type {(inputs: Misc_Posts_PublishedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Publisert 30. november 2023`)
};

const pl_misc_posts_published = /** @type {(inputs: Misc_Posts_PublishedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Opublikowano 30 listopada 2023`)
};

const pt_br2_misc_posts_published = /** @type {(inputs: Misc_Posts_PublishedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Publicado em 30 de novembro de 2023`)
};

const pt_misc_posts_published = /** @type {(inputs: Misc_Posts_PublishedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Publicado em 30 de novembro de 2023`)
};

const ro_misc_posts_published = /** @type {(inputs: Misc_Posts_PublishedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Publicat pe 30 noiembrie 2023`)
};

const fi_misc_posts_published = /** @type {(inputs: Misc_Posts_PublishedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Julkaistu 30. marraskuuta 2023`)
};

const sv_misc_posts_published = /** @type {(inputs: Misc_Posts_PublishedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Publicerad 30 november 2023`)
};

const vi_misc_posts_published = /** @type {(inputs: Misc_Posts_PublishedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Đã đăng vào ngày 30 tháng 11 năm 2023`)
};

const tr_misc_posts_published = /** @type {(inputs: Misc_Posts_PublishedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`30 Kasım 2023'te yayınlandı`)
};

const cs_misc_posts_published = /** @type {(inputs: Misc_Posts_PublishedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Publikováno 30. listopadu 2023`)
};

const bg_misc_posts_published = /** @type {(inputs: Misc_Posts_PublishedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Публикувано на 30 ноември 2023 г.`)
};

const ru_misc_posts_published = /** @type {(inputs: Misc_Posts_PublishedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Опубликовано 30 ноября 2023 г.`)
};

const uk_misc_posts_published = /** @type {(inputs: Misc_Posts_PublishedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Опубліковано 30 листопада 2023 р.`)
};

const ar_misc_posts_published = /** @type {(inputs: Misc_Posts_PublishedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`نُشر في 30 نوفمبر 2023`)
};

const hi_misc_posts_published = /** @type {(inputs: Misc_Posts_PublishedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`30 नवंबर 2023 को प्रकाशित`)
};

const th_misc_posts_published = /** @type {(inputs: Misc_Posts_PublishedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`เผยแพร่เมื่อ 30 พฤศจิกายน 2023`)
};

const ja_misc_posts_published = /** @type {(inputs: Misc_Posts_PublishedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`2023年11月30日公開`)
};

const zh_cn2_misc_posts_published = /** @type {(inputs: Misc_Posts_PublishedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`发布于 2023年11月30日`)
};

const zh_hant1_misc_posts_published = /** @type {(inputs: Misc_Posts_PublishedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`發布於 2023年11月30日`)
};

const ko_misc_posts_published = /** @type {(inputs: Misc_Posts_PublishedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`2023년 11월 30일 게시됨`)
};

/**
* | output |
* | --- |
* | "Published on November 30, 2023" |
*
* @param {Misc_Posts_PublishedInputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const misc_posts_published = /** @type {((inputs?: Misc_Posts_PublishedInputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Misc_Posts_PublishedInputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_misc_posts_published(inputs)
	if (locale === "ms") return ms_misc_posts_published(inputs)
	if (locale === "da") return da_misc_posts_published(inputs)
	if (locale === "de") return de_misc_posts_published(inputs)
	if (locale === "en-US") return en_us2_misc_posts_published(inputs)
	if (locale === "es-ES") return es_es2_misc_posts_published(inputs)
	if (locale === "es-MX") return es_mx2_misc_posts_published(inputs)
	if (locale === "fil") return fil_misc_posts_published(inputs)
	if (locale === "fr") return fr_misc_posts_published(inputs)
	if (locale === "it") return it_misc_posts_published(inputs)
	if (locale === "hu") return hu_misc_posts_published(inputs)
	if (locale === "nl") return nl_misc_posts_published(inputs)
	if (locale === "no") return no_misc_posts_published(inputs)
	if (locale === "pl") return pl_misc_posts_published(inputs)
	if (locale === "pt-BR") return pt_br2_misc_posts_published(inputs)
	if (locale === "pt") return pt_misc_posts_published(inputs)
	if (locale === "ro") return ro_misc_posts_published(inputs)
	if (locale === "fi") return fi_misc_posts_published(inputs)
	if (locale === "sv") return sv_misc_posts_published(inputs)
	if (locale === "vi") return vi_misc_posts_published(inputs)
	if (locale === "tr") return tr_misc_posts_published(inputs)
	if (locale === "cs") return cs_misc_posts_published(inputs)
	if (locale === "bg") return bg_misc_posts_published(inputs)
	if (locale === "ru") return ru_misc_posts_published(inputs)
	if (locale === "uk") return uk_misc_posts_published(inputs)
	if (locale === "ar") return ar_misc_posts_published(inputs)
	if (locale === "hi") return hi_misc_posts_published(inputs)
	if (locale === "th") return th_misc_posts_published(inputs)
	if (locale === "ja") return ja_misc_posts_published(inputs)
	if (locale === "zh-CN") return zh_cn2_misc_posts_published(inputs)
	if (locale === "zh-Hant") return zh_hant1_misc_posts_published(inputs)
	return ko_misc_posts_published(inputs)
});
export { misc_posts_published as "misc.posts.published" }